import { globalLeadSource } from 'hx-analytics/src/functions/url-lead-source/get-url-lead-source.helper';
import { useSelector } from 'react-redux';
import { isUserDetails } from '@/components/user-details/helpers/is-user-details.helper';
export function useTestCompletionCallback() {
    var _a = useSelector(function (state) { return state; }), dinTest = _a.dinTest, wizard = _a.wizard, widget = _a.widget;
    function handleTestCompletion() {
        var _a;
        if (!isUserDetails(widget.userDetails)) {
            console.error("userDetails type error: ".concat(widget.userDetails));
            return;
        }
        var userDetails = widget.userDetails;
        var testData = {
            first_name: userDetails['first-name'],
            last_name: userDetails['last-name'],
            email: userDetails['email'],
            contact_number: "+1".concat(userDetails['contact-number']),
            snr_result: Number(dinTest.result.averageSnr),
            hearing_category: dinTest.result.category,
            user_selected_volume: Number(wizard.form.volume),
            source: globalLeadSource ||
                "".concat(process.env.REACT_APP_SALESFORCE_LEADS_SOURCE_PREFIX),
            consent: userDetails['consent'],
            newsletter_consent: userDetails['consent'],
        };
        (_a = window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'host/test-complete', payload: testData }, '*');
    }
    return handleTestCompletion;
}
